import React from "react";
import PreApproveVesselCallDrawer from "./pre-approve/PreApproveVesselCallDrawer";

interface CloseVesselCallDrawerProps {
  isOpen: boolean;
  onClose: (drawerName: string) => void;
  onDocumentUpload?: (file: File) => void;
  onAdditionalDocumentUpload?: (file: File) => void;
  onSubmit?: (payload?: any) => void;
}

const CloseVesselCallDrawer: React.FC<CloseVesselCallDrawerProps> = (props) => (
  <PreApproveVesselCallDrawer
    {...props}
    drawerName="closeVesselCallDrawer"
    titleKey="vessel-call.close-vessel-call.title"
    subtitleKey="vessel-call.close-vessel-call.subtitle"
    submitLabelKey="vessel-call.close-vessel-call.submit"
    externalNotesLabelKey="vessel-call.close-vessel-call.notes-to-agent"
    externalAttachmentsLabelKey="vessel-call.close-vessel-call.attachments-for-agent"
    submitStatus="CLOSED"
  />
);

export default CloseVesselCallDrawer;
